export const LoginInitialValues = {
	number: 0,
	code: '',
}
